import axios from "axios";
import { reqAuth } from "@/api/api_request";
import qs from "qs";
import { GetQueryString } from "@/utils/utils";

function checkUserLogin() {
  return reqAuth.get(`auth/checkUserLogin`);
}

// 获取客户端信息
function getClient(username) {
  let host = GetQueryString("host") || location.host;
  return reqAuth.get(
    `anonymous/getClient?appId=12&serverName=${host}&username=${username}`,
    { auth: false }
  );
}

// 获取项目信息信息
function getProjectInfo(projectId, token) {
  return reqAuth.get(`auth/getProjectInfo?projectId=${projectId}`);
}

// 获取项目名称
function getProjectName() {
  let host = GetQueryString("host") || location.host;
  return reqAuth.get(`anonymous/getProjectName?appId=12&serverName=${host}`, {
    auth: false
  });
}

// 登录
function login(data) {
  return reqAuth.post("oauth/token", qs.stringify(data), { auth: false });
}

//referer登录
function refererLogin(params) {
  let url = "/d_web_api/user_manage/loginByReferer";
  return axios.post(url, params);
}

// 获取用户信息
function getAuthUserInfo(proId) {
  return reqAuth.get("auth/getUserInfo?proId=" + proId);
}

// 获取用户权限
function getUserMenuPower() {
  let url = `auth/getUserMenuPower?appId=12`;
  return reqAuth.get(url);
}

export {
  checkUserLogin,
  getClient,
  getProjectInfo,
  getProjectName,
  login,
  getAuthUserInfo,
  getUserMenuPower,
  refererLogin
};



// WEBPACK FOOTER //
// ./src/api/api.js